import React from 'react';
import Route from '../../layout/LayoutRoute';

const NotFoundComponent = React.lazy(() => import('.'));

const LoadableNotFound = () => <NotFoundComponent />;

const route = (
    <Route path="*">
        <LoadableNotFound />
    </Route>
);

export default route;
